// Populate (Amount of units) field with nº units product has, when adding a new booking on calendar
export function populateAmountUnitsDropdown(totalUnits, productType) {
  let dropdown;
  let formGroup;

  if (productType === 'Accommodation') {
    dropdown = document.querySelector(
      '#addAccommodationForm [name="amount_units"]',
    );
    formGroup = dropdown.closest('.form-group'); // Assuming the dropdown is a direct child of the form-group
  } else if (productType === 'Tour') {
    dropdown = document.querySelector('#addTourForm [name="amount_units"]');
    formGroup = dropdown.closest('.form-group');
  }

  if (dropdown && formGroup) {
    // Clear existing options
    dropdown.innerHTML = '';

    // Populate with new options
    for (let i = 1; i <= totalUnits; i++) {
      const option = document.createElement('option');
      option.value = i;
      option.textContent = i;
      dropdown.appendChild(option);
    }

    // Hide the form group if there's only 1 unit, otherwise show it
    if (totalUnits === 1) {
      formGroup.style.display = 'none';
    } else {
      formGroup.style.display = ''; // Resets any inline style, reverting to default CSS
    }
  }
}
